import type { ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";

import "./Spinner.styles.css";

type SpinnerProps = ComponentProps<"span">;

export function Spinner2({ className }: SpinnerProps) {
  return (
    <span
      className={cn(
        "tw:w-10 tw:aspect-square tw:rounded-full tw:border-2 tw:border-solid tw:border-[currentColor]",
        "chasing-rotation", // can't be called "spinner" or "loading" because Cypress waitForSpinnersToDisappear will pick it up
        // get.Spinner, .spinner, [class*="spinner"], [class*="loading"], [data-testid*="loading"], [data-testid*="spinner"]
        className,
      )}
    />
  );
}
